// Imports
import React, { Component } from 'react';

// CSS
import './../styles/css/galaxy.css';

class Galaxy extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className="galaxy">
                <div className="stars">
                    <div className="stars1"></div>
                    <div className="stars2"></div>
                    <div className="stars3"></div>
                </div>
            </div>
        );
    }
}

export default Galaxy;
